import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseRichService } from './base-rich.service';

@Injectable()
export class AccountService extends BaseRichService {

  updatePostalCode(postal_code) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });
    const body = {
      postal_code
    };

    return this.http.post(this.url + 'api/account/update_postal_code', body, { headers: headers });
  }

  sendAccountPassword(username: string, mobile: string, lang: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const body = {
      username: username,
      mobile: mobile,
      lang: lang
    };
    return this.http.post(this.url + 'api/account/send_account_password', body, { headers: headers });
  }

  sendOTP(username: string, lang: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const body = {
      username,
      lang
    };
    return this.http.post(this.url + 'api/account/send_otp', body, { headers: headers });
  }

  changePassword(currentPassword: string, newPassword: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });
    const body = {
      currentPassword: currentPassword,
      newPassword: newPassword
    };

    return this.http.post(this.url + 'api/account/change_password', body, { headers: headers });
  }

}
